
export const COUNTRIES = [
  { code: 'US', name: 'United States', label: 'US - United States' },
  { code: 'UK', name: 'Europe', label: 'UK - Europe' },
  { code: 'AU', name: 'Australia', label: 'AU - Australia' },
  { code: 'GBL', name: 'Global', label: 'GBL - Global' },
];

export const getCountryName = (code: string): string => {
  const country = COUNTRIES.find(c => c.code === code);
  return country ? country.name : code;
};

export const getCountryLabel = (code: string): string => {
  const country = COUNTRIES.find(c => c.code === code);
  return country ? country.label : code;
};

// Helper function to normalize country codes
export const normalizeCountryCode = (code: string): string => {
  // Convert GB to UK for consistency
  if (code === 'GB') return 'UK';
  return code;
};

export const TAX_PERCENTAGES = [
  { value: 10, label: '10%' },
  { value: 12, label: '12%' },
  { value: 24, label: '24%' }
];

export const calculateNetRoyaltyIncome = (grossRoyaltyIncome: number, taxPercentage: number): number => {
  return grossRoyaltyIncome * (1 - taxPercentage / 100);
};
